import { FC, useMemo } from 'react';

import { Tab, TabView } from 'components';
import SuccessDialog from 'components/organization/dialog/success-dialog';

import CustomerMappings from './customer-mappings';
import SizeTypeMappings from './size-type-mappings';
import './fleet-files.scss';

const FleetFileConfiguration: FC = () => {
  const tabs: Tab[] = useMemo(
    () => [
      { label: 'Account Mappings', content: <CustomerMappings /> },
      { label: 'Size Type Mappings', content: <SizeTypeMappings /> }
    ],
    []
  );

  return (
    <div
      id="fleet-file-configuration"
      className="d-flex flex-column flex-fill overflow-hidden"
      style={{ maxHeight: 'calc(100vh - 156px)' }}
    >
      <TabView tabs={tabs} variant="embedded" />
      <SuccessDialog />
    </div>
  );
};

export default FleetFileConfiguration;
